import { BaseRouteService } from 'core/services';

class FacilityPumpRouteService extends BaseRouteService {
    constructor() {
        super('facility-pumps');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,facilityId,statusId,productId,corporateId}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }

    getStatus(){
        return super.get(this.base + '/status');        
    }

    updateStatus(resource){
        return super.update(this.base + '/{id}/status', resource);                
    }

    getActiveNumber(facilityId){
        return super.get(this.base + '/{facilityId}/active-number', null, {facilityId: facilityId});        
    }

    getExisting(facilityId, productId, serialNumber){
        return super.get(this.base + '/existing/{facilityId}/{productId}/{serialNumber}', null, {
            facilityId: facilityId,
            productId: productId,
            serialNumber: serialNumber
        })
    }

    download(filter) {
        return super.find(this.base + '/download/{?searchQuery,rpp,page,sort,facilityId,productId,corporateId}', filter);    
    }
}

export default FacilityPumpRouteService;
